module.exports = __webpack_public_path__ + "img/australia-cancer-female.c2aec80f.png";